// utils/faviconUtils.js

/**
 * Update the favicon of the page
 * @param {string} faviconUrl - The URL of the new favicon
 */
export const updateFavicon = (faviconUrl) => {
  try {
    const href = faviconUrl || '/T.png';
    // find or create a link[rel~="icon"]
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'icon');
      document.head.appendChild(link);
    }
    // set sensible attributes
    link.setAttribute('type', 'image/png');
    // update only when different to avoid unnecessary DOM writes
    if (link.href !== href) {
      // if relative path provided, make it absolute relative to origin
      try {
        const url = new URL(href, window.location.origin).toString();
        link.href = url;
      } catch (e) {
        link.href = href;
      }
    }
  } catch (err) {
    // noop on servers or restricted environments
    // console.warn('updateFavicon error', err);
  }
};

/**
 * Remove the favicon from the page
 */
export const removeFavicon = () => {
  try {
    // Find and remove all favicon links
    const faviconLinks = document.querySelectorAll("link[rel*='icon']");
    faviconLinks.forEach(link => link.remove());
    
    // Also remove apple touch icon if exists
    const appleTouchIcon = document.querySelector("link[rel='apple-touch-icon']");
    if (appleTouchIcon) {
      appleTouchIcon.remove();
    }
  } catch (err) {
    // noop in non-browser environments
  }
};

/**
 * Update the page title
 * @param {string} title - The new page title
 */
export const updatePageTitle = (title) => {
  try {
    document.title = title || 'Truyon';
  } catch (err) {
    // noop in non-browser environments
  }
};

/**
 * Reset all branding to default
 */
export const resetBranding = () => {
  try {
    removeFavicon();
    document.title = 'Truyon';
    localStorage.removeItem('tenantFavicon');
    localStorage.removeItem('tenantTitle');
    localStorage.removeItem('tenantBranding');
  } catch (err) {
    // noop
  }
};

/**
 * Get current branding from localStorage
 * @returns {Object|null} - Current branding data or null
 */
export const getCurrentBranding = () => {
  try {
    const branding = localStorage.getItem('tenantBranding');
    if (branding) {
      return JSON.parse(branding);
    }
    return null;
  } catch (error) {
    console.error('Error getting current branding:', error);
    return null;
  }
};